export interface Pattern {
  id: string;
  name: string;
}

const patterns: Pattern[] = [
  { id: 'none', name: 'None' },
  { id: 'waves', name: 'Ocean Waves' },
  { id: 'peaks', name: 'Mountain Peaks' },
  { id: 'blobs', name: 'Organic Blobs' },
  { id: 'circles', name: 'Floating Circles' },
  { id: 'diagonal', name: 'Diagonal Lines' },
  { id: 'dots', name: 'Dot Grid' },
  { id: 'hexagons', name: 'Hexagons' },
  { id: 'zigzag', name: 'Zigzag' },
  { id: 'topo', name: 'Topographic' },
  { id: 'aurora', name: 'Aurora' },
];

export default patterns;
